import { CalendarIcon } from '@panwds/icons';
import { usePopper, Select, Portal, Card } from '@panwds/react-ui';
import { classNames } from '@panwds/tailwindcss';
import isEqual from 'lodash/isEqual';
import React, { useState, useMemo, cloneElement } from 'react';
import { FocusOn } from 'react-focus-on';
import { useFilters } from '../../hooks/useFilters/useFilters.esm.js';
import { PillValue } from '../Pill/PillValue.esm.js';

const emptyItems = [];
const BaseDateFilter = ({ autoFocus, enableInitialFocus, customText = 'Custom', name, label, items = emptyItems, onClose, disabled, customLabel, Picker, addClassName, addContainerClassName, noCustom = false, id = 'base-date-filter', ...rest }) => {
    const [datepickerOpen, setDatepickerOpen] = useState(false);
    const { filters, setFilters } = useFilters();
    const { triggerRef, containerRef } = usePopper({
        placement: 'bottom-start',
        strategy: 'fixed'
    });
    const currentFilters = filters[name];
    const ItemCustom = {
        value: 'custom',
        children: customText,
        key: 'custom'
    };
    const customItem = {
        ...ItemCustom,
        onClick: () => {
            setDatepickerOpen(!datepickerOpen);
        }
    };
    const pillProps = datepickerOpen ? { isOpen: true } : {};
    const cancelCustom = () => {
        setDatepickerOpen(false);
    };
    const selectedItem = useMemo(() => {
        if (!currentFilters)
            return;
        const item = items.find(({ value }) => isEqual(value, currentFilters));
        return item !== null && item !== void 0 ? item : ItemCustom;
    }, [currentFilters]);
    const clonedPicker = cloneElement(Picker, {
        ...rest,
        onApply: (date) => {
            setFilters({
                [name]: Picker.props.onApply(date)
            });
            setDatepickerOpen(false);
        },
        onCancel: cancelCustom
    });
    const selectedItemLabel = selectedItem
        ? selectedItem.value === 'custom'
            ? customLabel(currentFilters)
            : `${selectedItem.children || selectedItem.value}`
        : `Select ${label}`;
    const wrapper = (React.createElement(Select, { addClassName: addContainerClassName, selectedItem: selectedItem, disabled: disabled, enableInitialFocus: enableInitialFocus, items: !noCustom ? [...items, customItem] : [...items], button: React.createElement(PillValue, { ...pillProps, autoFocus: autoFocus, labelKey: label, labelValue: selectedItemLabel, disabled: disabled, addClassName: classNames(addClassName, 'tw-rounded'), displayAsString: true, onClose: onClose, required: rest.required, leftIcon: React.createElement(CalendarIcon, { size: "sm", className: "tw-text-gray-500 dark:tw-text-gray-400 tw-mr-1" }) }), onChange: ({ selectedItem }) => {
            setFilters({
                [name]: selectedItem.value
            });
        }, buttonRef: triggerRef }));
    return (React.createElement("div", { id: id },
        wrapper,
        React.createElement(Portal, null,
            React.createElement("div", { className: "tw-z-20", ref: containerRef }, datepickerOpen && (React.createElement(FocusOn, { enabled: datepickerOpen, noIsolation: true, onClickOutside: cancelCustom, onEscapeKey: cancelCustom, scrollLock: false },
                React.createElement(Card, { role: "dialog", style: { margin: '0.1rem 0' } }, clonedPicker)))))));
};

export { BaseDateFilter };
//# sourceMappingURL=BaseDateFilter.esm.js.map
